import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export const OcjeneGroupedDataTable = (props) => {
  const [ocjene, setOcjene] = useState();
  const [expandedRows, setExpandedRows] = useState([]);

  useEffect(() => {
    setOcjene(props.data);
  }, [props.data]);

  const headerTemplate = (data) => {
    return (
      <React.Fragment>
        <span>{data.naziv_predmeta}</span>
      </React.Fragment>
    );
  };

  return (
    <div className="centerText">
      <DataTable
        value={ocjene}
        rowGroupMode="subheader"
        groupRowsBy="naziv_predmeta"
        responsiveLayout="scroll"
        expandableRowGroups
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowGroupHeaderTemplate={headerTemplate}
      >
        <Column
          field="naziv_predmeta"
          header="Predmet"
          className="table-column-default"
        ></Column>
        <Column
          field="datum"
          header="Datum"
          className="table-column-date"
        ></Column>
        <Column
          field="biljeska"
          header="Bilješka"
          className="table-column-course"
        ></Column>
        <Column
          field="ocjena"
          header="Ocjena"
          className="table-column-grade"
        ></Column>
      </DataTable>
    </div>
  );
};

export default OcjeneGroupedDataTable;
